import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import { isNil } from 'lodash';
import { imageByDpi, productImage } from 'util/react/stack-images-path';
import { BADGE_TILE, THUMB } from 'constants/api-images-types';

import Loader from 'components/loader';
import Icon from 'components/icon';
import formatPrice from 'util/misc/format-price';
import t from 'translations';
import formatProductShortDescription from 'util/react/format-product-short-description';
import ProductPrice from 'components/product-price';

class CartProductsListProductInfo extends PureComponent {
    static propTypes = {
        item: PropTypes.object.isRequired,
        fetchingId: PropTypes.string,
        add: PropTypes.func.isRequired,
        pathname: PropTypes.string,
        openModal: PropTypes.func.isRequired,
        closePanel: PropTypes.func.isRequired,
        routerRegistry: PropTypes.object.isRequired,
    };

    openProductDetailOverlay = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const href = e.currentTarget.getAttribute('href');

        // if href is the same of the current page we can close the panel
        // it means we are already in the right page
        if (this.props.pathname === href) {
            this.props.closePanel();
        } else {
            this.props.openModal({
                layout: 'product-detail',
                isAsync: true,
                href,
            });
        }
    };

    render() {
        const { add, item, item: { product }, fetchingId, routerRegistry } = this.props;
        const { badge, original_price } = product.price_information;
        const hasDiscount = !isNil(original_price);

        return (
            <div className="cart-products-list--product" onClick={() => add()}>
                <figure className="cart-products-list--figure"
                    style={{ backgroundImage: `url(${ imageByDpi(productImage(product.image, THUMB)) })` }}>
                </figure>
                <div className="cart-products-list--detail">
                    {badge ? <img className="cart-products-list--product-badge"
                        src={imageByDpi(productImage(badge, BADGE_TILE))}/> : null}
                    <div className="cart-products-list--detail-inner">
                        <div className="cart-products-list--product-info">
                            <h2 className="cart-products-list--product-title u-reset">
                                {product.name}
                            </h2>
                            {product.short_description &&
                            <p className="cart-products-list--product-description">{formatProductShortDescription(product.short_description)}</p>}
                            <footer className="cart-products-list--price-info">
                                <ProductPrice price_information={product.price_information}
                                    rootClass="cart-products-list"/>
                            </footer>
                        </div>
                        <div className="cart-products-list--action-bar">
                            <div
                                className={classnames('cart-products-list--total-price', { 'cart-products-list--total-price__discount': hasDiscount }, { 'cart-products-list--total-price__loader': fetchingId === product.id })}>
                                <span className="cart-products-list--loader">
                                    {fetchingId === product.id && <Loader size={'small'}/>}
                                </span>
                                <span className={'cart-products-list--total-price-amount'}>
                                    {formatPrice(item.total_price)}
                                </span>
                            </div>
                            <Link className="cart-products-list--detail-button u-reset"
                                aria-label={t('accessibility.label.product_detail')}
                                to={`${ routerRegistry.get() }/${ product.slug }`}
                                onClick={this.openProductDetailOverlay}>
                                <Icon symbol="product-detail" size="large"
                                    className={'cart-products-list--detail-icon'}/>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        fetchingId: 'cart.fetchingId',
        pathname: 'router.location.pathname',
        routerRegistry: 'router.registry',
    }),
    reduxUtils.mapDispatchToProps({
        closePanel: 'panel.close',
        openModal: 'modal.open',
    }),
)(CartProductsListProductInfo);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cart-products-list/product-info/index.js